import { PMLevelCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addOverallCompletionCard(ctx: DashboardCardContext) {
  const { view, language } = ctx;

  const overallCompletionCard = view.addComponent({
    component: PMLevelCard,
    layoutProps: {
      componentId: "overallCompletionCard",
      title:
        getLocalizedMessage(language, "cards.overallCompletion.title") ||
        "Overall Completion",
      description: getLocalizedMessage(
        language,
        "cards.overallCompletion.description"
      ),
      labels: ["overallCompletion"],
    },
  });
  overallCompletionCard.mapState(({ dashboard, settings }) => {
    return {
      title:
        getLocalizedMessage(language, "cards.overallCompletion.title") ||
        "Overall Completion",
      categories: [
        {
          value: dashboard?._calculated?.overallCompletionDegree?.name ?? "",
          valueColor:
            settings?.configuration?.degreeOfCompletionDefinition?.find(
              (cat) =>
                cat.name ===
                dashboard?._calculated?.overallCompletionDegree?.name
            )?.color ?? "#E1F1E7",
          textColor: "#fff",
        },
      ],
      showInfoIcon: false,
      showMenuIcon: false,
    };
  });

  overallCompletionCard.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
